const axios = require('axios').default;

const axiosInstance = axios.create({});

module.exports = axiosInstance;
